import AdminConfigAlerts from './AdminConfigAlerts';
export default AdminConfigAlerts;
